module.exports = __webpack_public_path__ + "static/media/post-4.a40aa059.png";